<template>
  <div class="result-input">
    <!-- PC時 -->
    <div
      v-if="!isMobile"
      class="mb-16 py-12"
    >
      <div>
        <validation-observer ref="observer" slim v-if="isCampaignStarted && !propsIsLoading">
          <!-- <v-snackbar
            v-model="showHasChange"
            color="pink"
            timeout="-1"
            top
          >
            記録をしたら、「保存する」ボタンを押して下さい。
          </v-snackbar> -->
          <!-- <v-snackbar
            v-model="hasError"
            color="amber lighten-2"
            timeout="-1"
            top
            light
          >
            {{errorMessage}}
          </v-snackbar> -->
          <table class="result-input-table c-custom--w-100 font-weight-bold c-result-font-roboto--500">
            <thead>
              <tr>
                <th class="th-days"></th>
                <th class="th-check"></th>
                <th v-for="(course) in selectedCourseList"
                  :key="course.id"
                >
                  <div
                    class="result-input-table-th__row"
                  >
                    <div
                      class="result-input-table-th__col result-input-table-th__col--title"
                    >
                    {{course.name}}
                    <!-- カスタム目標設定コースの場合 -->
                    <span v-if="course.custom_goal_setting">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small>mdi-note</v-icon>
                        </template>
                        <span>{{course.custom_objective}}</span>
                      </v-tooltip>
                    </span>
                    </div>
                    <div
                      class="result-input-table-th__col result-input-table-th__col--info"
                    >
                      <v-btn
                        elevation="0"
                        icon
                        x-small
                        v-if="course.detailed_document_file_name !== ''"
                        @click="openDetailPDF(course.detailed_document_file_name)"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z" fill="#F5F5F5"/>
                          <path d="M8.73486 9.96191H6.9917C6.99626 9.55176 7.02816 9.19857 7.0874 8.90234C7.1512 8.60156 7.2583 8.3304 7.40869 8.08887C7.56364 7.84733 7.76872 7.60807 8.02393 7.37109C8.23812 7.17969 8.42497 6.9974 8.58447 6.82422C8.74398 6.65104 8.8693 6.47331 8.96045 6.29102C9.0516 6.10417 9.09717 5.89681 9.09717 5.66895C9.09717 5.40462 9.05615 5.18587 8.97412 5.0127C8.89665 4.83496 8.77816 4.70052 8.61865 4.60938C8.4637 4.51823 8.26774 4.47266 8.03076 4.47266C7.8348 4.47266 7.65251 4.51595 7.48389 4.60254C7.31527 4.68457 7.17627 4.81217 7.06689 4.98535C6.96208 5.15853 6.90739 5.38639 6.90283 5.66895H4.92041C4.93408 5.0446 5.07764 4.52962 5.35107 4.12402C5.62907 3.71387 6.00049 3.41081 6.46533 3.21484C6.93018 3.01432 7.45199 2.91406 8.03076 2.91406C8.66878 2.91406 9.21566 3.01888 9.67139 3.22852C10.1271 3.43359 10.4757 3.73665 10.7173 4.1377C10.9588 4.53418 11.0796 5.01725 11.0796 5.58691C11.0796 5.9834 11.0021 6.33659 10.8472 6.64648C10.6922 6.95182 10.4894 7.23665 10.2388 7.50098C9.98812 7.7653 9.7124 8.03874 9.41162 8.32129C9.15186 8.55371 8.97412 8.79753 8.87842 9.05273C8.78727 9.30794 8.73942 9.611 8.73486 9.96191ZM6.78662 12.0742C6.78662 11.7826 6.88688 11.541 7.0874 11.3496C7.28792 11.1536 7.5568 11.0557 7.89404 11.0557C8.22673 11.0557 8.49333 11.1536 8.69385 11.3496C8.89893 11.541 9.00146 11.7826 9.00146 12.0742C9.00146 12.3568 8.89893 12.596 8.69385 12.792C8.49333 12.988 8.22673 13.0859 7.89404 13.0859C7.5568 13.0859 7.28792 12.988 7.0874 12.792C6.88688 12.596 6.78662 12.3568 6.78662 12.0742Z" fill="#19ADF8"/>
                        </svg>
                      </v-btn>
                    </div>
                  </div>
                </th>
                <th class="th-blood-pressure" v-if="!isSelectedBloodPressureCourse">血圧</th>
                <th class="th-memo">メモ欄</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dateValue) of dailyValueList" :key="dateValue.date" :class="dateValue.is_inputted ? 'is-updating' : ''">
                <td class="td-days">
                  <span class="td-days-year">{{dateValue.show_year}}</span>
                  <span :class="dateValue.day === 0 ? 'td-days-day is-sunday' : (dateValue.day === 6 ? 'td-days-day is-saturday' : (dateValue.isHoliday ? 'td-days-day is-sunday' : 'td-days-day'))">{{dateValue.show_date}}</span>
                </td>
                <td  class="td-check"><i v-if="dateValue.is_inputted" aria-hidden="true" class="v-icon notranslate mdi mdi-check-circle theme--light"></i></td>
                <td v-for="(course, index) in selectedCourseList" :key="course.id" :class="course.result_type === 'DualInteger' ? 'td-blood-pressure' : ''">
                  <!-- PepUpコースの場合 -->
                  <v-item-group v-if="course.is_pepup_cource">
                    <v-container class="pa-0">
                      <div
                        class="result-input__row c-custom--w-100 d-flex align-center justify-center"
                      >
                        <div class="result-input__col">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :class="{
                                'v-item--active': course.aggregate_result_info.is_completed,
                                'outlined-when-disabled': true
                              }"
                              :disabled="true"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--on d-flex justify-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                    <circle cx="7.70834" cy="8" r="5.90909" stroke-width="2.36364"/>
                                  </svg>
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </v-container>
                  </v-item-group>
                  <!-- 〇✕入力の場合 -->
                  <v-item-group v-if="(course.result_type === 'CircleAndCross' || course.result_type === 'CircleCrossNone') && !course.is_pepup_cource">
                    <v-container class="pa-0">
                      <div
                        class="result-input__row c-custom--w-100 d-flex align-center justify-space-between"
                      >
                        <div class="result-input__col">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :class="{'v-item--active': dateValue.select_course_result[index].circle_and_cross === 'circle',
                                        'outlined-when-disabled': isSubmitting || !isCampaignPeriod}"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              @click="toggleSelection('circle', dateValue, index)"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--on d-flex justify-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                    <circle cx="7.70834" cy="8" r="5.90909" stroke-width="2.36364"/>
                                  </svg>
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                        <div class="result-input__col">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :class="{'v-item--active': dateValue.select_course_result[index].circle_and_cross === 'cross',
                                      'outlined-when-disabled': isSubmitting || !isCampaignPeriod}"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              @click="toggleSelection('cross', dateValue, index)"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--off d-flex align-center justify-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                                    <path d="M12.568 11.6895C13.0512 12.1726 12.8301 12.9975 12.1701 13.1743C11.8639 13.2563 11.537 13.1688 11.3128 12.9446L6.62496 8.25572L1.93561 12.9431C1.45248 13.4262 0.627512 13.2052 0.450674 12.5453C0.368602 12.239 0.45617 11.9122 0.680395 11.688L5.36974 7.00063L0.681869 2.31177C0.198739 1.82868 0.419784 1.0038 1.07976 0.826978C1.38605 0.744919 1.71286 0.832478 1.93709 1.05668L6.62496 5.74554L11.3143 1.05594C11.7974 0.572853 12.6224 0.79388 12.7992 1.45378C12.8813 1.76005 12.7937 2.08683 12.5695 2.31103L7.88017 7.00063L12.568 11.6895Z" />
                                  </svg>
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                        <div class="result-input__col" v-if="course.result_type === 'CircleCrossNone'">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :class="{'v-item--active': dateValue.select_course_result[index].circle_and_cross === 'none',
                                      'outlined-when-disabled': isSubmitting || !isCampaignPeriod}"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              @click="toggleSelection('none', dateValue, index)"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--off d-flex align-center justify-center" :class="{'active-txt': dateValue.select_course_result[index].circle_and_cross === 'none'}" style="font-size: 0.8rem;">
                                  該当<br/>なし
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </v-container>
                  </v-item-group>
                  <!-- 整数入力の場合 -->
                  <div v-if="course.result_type === 'Integer'">
                    <keep-alive>
                      <validation-provider
                        :name="course.name"
                        :rules="setRule(course.result_type)"
                        v-slot="{ errors }"
                        :vid="'attribute-' + course.id + '-' + dateValue.date"
                      >
                        <v-text-field
                          :value="dateValue.select_course_result[index].integer"
                          :error-messages="errors"
                          :disabled="isSubmitting || !isCampaignPeriod"
                          outlined
                          height="60"
                          class="c-custom--v-input"
                          hide-details="auto"
                          @input="changeIntegerData($event, dateValue, index)"
                        >
                        </v-text-field>
                        <span v-if="!errors.length" class="result-input__subtext result-input__subtext--unit">
                          {{ course.unit }}
                        </span>
                        <div class="text-center" style="width: 100%;">
                          <v-chip
                            v-if="dateValue.select_course_result[index].is_manual"
                            class="mt-1" small
                            color="primary"
                            outlined
                          >
                            手動入力
                          </v-chip>
                        </div>
                      </validation-provider>
                    </keep-alive>
                  </div>
                  <!-- 小数点あり入力の場合 -->
                  <div v-if="course.result_type === 'Number'">
                    <keep-alive>
                      <validation-provider
                        :name="course.name"
                        :rules="setRule(course.result_type)"
                        v-slot="{ errors }"
                        :vid="'attribute-' + course.id + '-' + dateValue.date"
                      >
                        <v-text-field
                          :value="dateValue.select_course_result[index].number"
                          :error-messages="errors"
                          :disabled="isSubmitting || !isCampaignPeriod"
                          outlined
                          height="60"
                          class="c-custom--v-input"
                          hide-details="auto"
                          @input="changeNumberData($event, dateValue, index)"
                        >
                        </v-text-field>
                        <span v-if="!errors.length" class="result-input__subtext result-input__subtext--unit">
                          {{ course.unit }}
                        </span>
                        <div class="text-center" style="width: 100%;">
                          <v-chip
                            v-if="dateValue.select_course_result[index].is_manual"
                            class="mt-1" small
                            color="primary"
                            outlined
                          >
                            手動入力
                          </v-chip>
                        </div>
                      </validation-provider>
                    </keep-alive>
                  </div>
                  <!-- 2項目整数入力の場合（血圧コース） -->
                  <div v-if="course.result_type === 'DualInteger'">
                    <div
                      class="td-blood-pressure__row"
                    >
                      <div
                        class="td-blood-pressure__col td-blood-pressure__col--title"
                      >
                        <span class="result-input__subtext">上</span>
                      </div>
                      <div
                        class="td-blood-pressure__col td-blood-pressure__col--input"
                      >
                        <keep-alive>
                          <validation-provider
                            :name="course.name"
                            :rules="setRule(course.result_type)"
                            v-slot="{ errors }"
                            :vid="'attribute-' + course.id + '-' + dateValue.date + '-1'"
                          >
                            <v-text-field
                              :value="dateValue.select_course_result[index].dual_integer_1"
                              :error-messages="errors"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              outlined
                              height="29"
                              class="c-custom--v-input"
                              hide-details="auto"
                              @input="changeDualInteger1Data($event, dateValue, index)"
                            >
                            </v-text-field>
                          </validation-provider>
                        </keep-alive>
                      </div>
                    </div>
                    <div
                      class="td-blood-pressure__row"
                    >
                      <div
                        class="td-blood-pressure__col td-blood-pressure__col--title"
                      >
                        <span class="result-input__subtext">下</span>
                      </div>
                      <div
                        class="td-blood-pressure__col td-blood-pressure__col--input"
                      >
                        <keep-alive>
                          <validation-provider
                            :name="course.name"
                            :rules="setRule(course.result_type)"
                            v-slot="{ errors }"
                            :vid="'attribute-' + course.id + '-' + dateValue.date + '-2'"
                          >
                            <v-text-field
                              :value="dateValue.select_course_result[index].dual_integer_2"
                              :error-messages="errors"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              outlined
                              height="29"
                              class="c-custom--v-input"
                              hide-details="auto"
                              @input="changeDualInteger2Data($event, dateValue, index)"
                            >
                            </v-text-field>
                          </validation-provider>
                        </keep-alive>
                      </div>
                    </div>
                    <div class="text-center" style="width: 100%;">
                      <v-chip
                        v-if="dateValue.select_course_result[index].is_manual"
                        class="mt-1" small
                        color="primary"
                        outlined
                      >
                        手動入力
                      </v-chip>
                    </div>
                  </div>
                </td>
                <!-- 血圧の入力欄 -->
                <td class="td-blood-pressure" v-if="!isSelectedBloodPressureCourse">
                  <div
                    class="td-blood-pressure__row"
                  >
                    <div
                      class="td-blood-pressure__col td-blood-pressure__col--title"
                    >
                      <span class="result-input__subtext">上</span>
                    </div>
                    <div
                      class="td-blood-pressure__col td-blood-pressure__col--input"
                    >
                      <keep-alive>
                        <validation-provider
                          name="血圧(上)"
                          :rules="setRule('bloodPressure')"
                          v-slot="{ errors }"
                          :vid="'attribute-top_blood_pressure-' + dateValue.date"
                        >
                          <v-text-field
                            :value="dateValue.top_blood_pressure"
                            :error-messages="errors"
                            :disabled="isSubmitting || !isCampaignPeriod"
                            outlined
                            height="29"
                            class="c-custom--v-input"
                            :class="{'no-errors': !errors.length}"
                            @input="changeTopBloodPressure($event, dateValue)"
                          >
                          </v-text-field>
                        </validation-provider>
                      </keep-alive>
                    </div>
                  </div>
                  <div
                    class="td-blood-pressure__row"
                  >
                    <div
                      class="td-blood-pressure__col td-blood-pressure__col--title"
                    >
                      <span class="result-input__subtext">下</span>
                    </div>
                    <div
                      class="td-blood-pressure__col td-blood-pressure__col--input"
                    >
                      <keep-alive>
                        <validation-provider
                          name="血圧(下)"
                          :rules="setRule('bloodPressure')"
                          v-slot="{ errors }"
                          :vid="'attribute-bottom_blood_pressure-' + dateValue.date"
                        >
                          <v-text-field
                            :value="dateValue.bottom_blood_pressure"
                            :error-messages="errors"
                            :disabled="isSubmitting || !isCampaignPeriod"
                            outlined
                            height="29"
                            class="c-custom--v-input"
                            :class="{'no-errors': !errors.length}"
                            @input="changeBottomBloodPressure($event, dateValue)"
                          >
                          </v-text-field>
                        </validation-provider>
                      </keep-alive>
                    </div>
                  </div>
                </td>
                <!-- メモ欄 -->
                <td class="td-memo">
                  <v-textarea
                  :value="dateValue.note"
                  :disabled="isSubmitting || !isCampaignPeriod"
                  outlined
                  height="60"
                  name="input_memo"
                  class="c-custom--v-input no-errors"
                  @input="changeNote($event, dateValue)"
                  ></v-textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </validation-observer>
      </div>
    </div>

    <!-- SP時 -->
    <div
      v-if="isMobile"
      class="pt-12 pb-4"
    >
      <div>
        <!-- <v-snackbar
          v-model="hasError"
          color="amber lighten-2"
          timeout="-1"
          top
          light
        >
          {{errorMessage}}
        </v-snackbar> -->
        <div v-if="isCampaignStarted && !propsIsLoading">
          <v-toolbar
            flat
            class="c-custom--v-toolbar__content--space-between"
          >
          <!-- カレンダー上部「＜」ボタン -->
            <v-btn
              fab
              text
              small
              color="black"
              :disabled="!displayPrevMonth"
              @click="prev()"
            >
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-toolbar-title class="font-weight-bold">
              {{ formatDisplayYearMonthInfo }}
            </v-toolbar-title>
            <!-- カレンダー上部「＞」ボタン -->
            <v-btn
              fab
              text
              small
              color="black"
              :disabled="!displayNextMonth"
              @click="next()"
            >
              <v-icon>
                mdi-chevron-right
              </v-icon>
            </v-btn>
          </v-toolbar>
          <table class="result-input-table-sp c-custom--w-100 font-weight-bold c-result-font-roboto--500">
            <tr class="day-of-week">
              <td>日</td>
              <td>月</td>
              <td>火</td>
              <td>水</td>
              <td>木</td>
              <td>金</td>
              <td>土</td>
            </tr>
            <tr v-for="(rowNum, rowNumIndex) in calendar" :key="rowNumIndex">
              <td v-for="(colNum, colNumIndex) in rowNum" :key="colNumIndex" :class="{'is-today': isToday(colNum.date)}">
                <v-btn
                  @click="setDateValueForSP(colNum.formatDate)"
                  :disabled="!colNum.canClick"
                  elevation="0"
                  class="c-custom--v-btn__content--block c-custom--w-100 result-input-table-sp-btn pa-0 font-weight-bold text-center"
                >
                  <span :class="colNum.weekday === 0 ? 'day sunday-red' : (colNum.weekday === 6 ? 'day saturday-blue' : (colNum.isHoliday ? 'day sunday-red' : 'day'))">{{ colNum.day }}</span>
                  <span class="is-clear-soon" v-if="getDailyInfo(colNum.formatDate) && getDailyInfo(colNum.formatDate).is_inputted">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <circle opacity="0.7" cx="11" cy="11" r="9.5" stroke="#19ADF8" stroke-width="3"/>
                    </svg>
                  </span>
                </v-btn>
              </td>
            </tr>
          </table>
        </div>
        <!-- カレンダー日付押下時のダイアログ -->
        <validation-observer ref="observer" slim v-if="isCampaignStarted && !propsIsLoading">
          <v-dialog
            v-if="spDialogReady"
            v-model="InputDialog"
            scrollable
            :max-width="1200"
            class="result-input-dialog"
          >
            <v-card outlined>
              <!-- モーダル内✕ボタン -->
              <v-btn
                fab
                small
                elevation="0"
                @click="InputDialog = false"
                class="c-result-dialog-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <!-- 各コース内容 -->
              <v-card-text
                class="c-custom--v-card-text"
              >

                <!-- 日付曜日（SP） -->
                <div
                  class="result-input-dialog-date mb-4 pl-2 font-weight-bold c-result-font-roboto--500"
                >
                  <div
                    class="result-input-dialog-date__year"
                  >
                    {{ dateValueForSP.show_year }}
                  </div>
                  <div
                    class="result-input-dialog-date__days"
                  >
                    {{ dateValueForSP.show_date }}
                  </div>
                </div>

                <div class="c-result-dialog-card mb-6" v-for="(course, index) in selectedCourseList" :key="course.id">
                  <v-row
                    no-gutters
                    class="justify-space-between align-center pb-4"
                  >
                    <v-col cols="8">
                      <span class="result-input-dialog__title ma-0 pb-3 font-weight-bold">{{ course.name }}</span>
                      <!-- カスタム目標設定コースの場合 -->
                      <span v-if="course.custom_goal_setting">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small>mdi-note</v-icon>
                          </template>
                          <span>{{course.custom_objective}}</span>
                        </v-tooltip>
                      </span>
                    </v-col>
                    <v-col cols="4">
                      <v-btn
                        rounded
                        elevation="0"
                        class="c-result-btn--gray result-input-dialog__btn c-custom--w-100 font-weight-bold text-center"
                        v-if="course.detailed_document_file_name !== ''"
                        @click="openDetailPDF(course.detailed_document_file_name)"
                      >
                        コース説明
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!-- PepUpコースの場合（SP） -->
                  <v-item-group v-if="course.is_pepup_cource">
                    <v-container class="pa-0">
                      <div
                        class="result-input__row c-custom--w-100 d-flex align-center justify-center"
                      >
                        <div class="result-input__col">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :class="{
                                'v-item--active': course.aggregate_result_info.is_completed,
                                'outlined-when-disabled': true
                              }"
                              :disabled="true"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--on d-flex justify-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 15 16" fill="none">
                                    <circle cx="7.70834" cy="8" r="5.90909" stroke-width="2.36364"/>
                                  </svg>
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </v-container>
                  </v-item-group>
                  <!-- 〇✕入力の場合（SP） -->
                  <v-item-group v-if="(course.result_type === 'CircleAndCross' || course.result_type === 'CircleCrossNone') && !course.is_pepup_cource">
                    <v-container class="pa-0">
                      <div class="result-input__row c-custom--w-100 d-flex align-center justify-space-between">
                        <div class="result-input__col">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              :class="{'v-item--active': dateValueForSP.select_course_result && dateValueForSP.select_course_result[index].circle_and_cross === 'circle',
                                      'outlined-when-disabled': isSubmitting || !isCampaignPeriod}"
                              @click="toggleSelection('circle', dateValueForSP, index)"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--on d-flex justify-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 15 16" fill="none">
                                    <circle cx="7.70834" cy="8" r="5.90909" stroke-width="2.36364"/>
                                  </svg>
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                        <div class="result-input__col">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              :class="{'v-item--active': dateValueForSP.select_course_result && dateValueForSP.select_course_result[index].circle_and_cross === 'cross',
                                      'outlined-when-disabled': isSubmitting || !isCampaignPeriod}"
                              @click="toggleSelection('cross', dateValueForSP, index)"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--off d-flex align-center justify-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 13 14" fill="none">
                                    <path d="M12.568 11.6895C13.0512 12.1726 12.8301 12.9975 12.1701 13.1743C11.8639 13.2563 11.537 13.1688 11.3128 12.9446L6.62496 8.25572L1.93561 12.9431C1.45248 13.4262 0.627512 13.2052 0.450674 12.5453C0.368602 12.239 0.45617 11.9122 0.680395 11.688L5.36974 7.00063L0.681869 2.31177C0.198739 1.82868 0.419784 1.0038 1.07976 0.826978C1.38605 0.744919 1.71286 0.832478 1.93709 1.05668L6.62496 5.74554L11.3143 1.05594C11.7974 0.572853 12.6224 0.79388 12.7992 1.45378C12.8813 1.76005 12.7937 2.08683 12.5695 2.31103L7.88017 7.00063L12.568 11.6895Z" />
                                  </svg>
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                        <div class="result-input__col" v-if="course.result_type === 'CircleCrossNone'">
                          <v-item>
                            <v-card
                              outlined
                              elevation="0"
                              height="60"
                              class="d-flex align-center justify-center"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              :class="{'v-item--active': dateValueForSP.select_course_result && dateValueForSP.select_course_result[index].circle_and_cross === 'none',
                                      'outlined-when-disabled': isSubmitting || !isCampaignPeriod}"
                              @click="toggleSelection('none', dateValueForSP, index)"
                            >
                              <v-scroll-y-transition>
                                <div class="input-select--off d-flex align-center justify-center" :class="{'active-txt': dateValueForSP.select_course_result && dateValueForSP.select_course_result[index].circle_and_cross === 'none'}" style="font-weight: bold;">
                                  該当なし
                                </div>
                              </v-scroll-y-transition>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </v-container>
                  </v-item-group>
                  <!-- 整数入力の場合（SP） -->
                  <div class="td-text-sp font-weight-bold" v-if="course.result_type === 'Integer'">
                    <keep-alive>
                      <validation-provider
                        :name="course.name"
                        :rules="setRule(course.result_type)"
                        v-slot="{ errors }"
                        :vid="'attribute-' + course.id + '-' + dateValueForSP.date"
                      >
                        <v-text-field
                          :value="dateValueForSP.select_course_result[index].integer"
                          :error-messages="errors"
                          :disabled="isSubmitting || !isCampaignPeriod"
                          outlined
                          height="50"
                          class="c-custom--v-input"
                          hide-details="auto"
                          @input="changeIntegerData($event, dateValueForSP, index)"
                        >
                        </v-text-field>
                        <span v-if="!errors.length" class="result-input__subtext result-input__subtext--unit">{{ course.unit }}</span>
                        <div class="is_manual_for_SP">
                          <v-chip
                            v-if="dateValueForSP.select_course_result[index].is_manual"
                            class="mt-1" small
                            color="primary"
                            outlined
                          >
                            手動入力
                          </v-chip>
                        </div>
                      </validation-provider>
                    </keep-alive>
                  </div>
                  <!-- 小数点あり入力の場合（SP） -->
                  <div class="td-text-sp font-weight-bold" v-if="course.result_type === 'Number'">
                    <keep-alive>
                      <validation-provider
                        :name="course.name"
                        :rules="setRule(course.result_type)"
                        v-slot="{ errors }"
                        :vid="'attribute-' + course.id + '-' + dateValueForSP.date"
                      >
                        <v-text-field
                          :value="dateValueForSP.select_course_result[index].number"
                          :error-messages="errors"
                          :disabled="isSubmitting || !isCampaignPeriod"
                          outlined
                          height="50"
                          class="c-custom--v-input"
                          hide-details="auto"
                          @input="changeNumberData($event, dateValueForSP, index)"
                        >
                        </v-text-field>
                        <span v-if="!errors.length" class="result-input__subtext result-input__subtext--unit">{{ course.unit }}</span>
                        <div class="is_manual_for_SP">
                          <v-chip
                            v-if="dateValueForSP.select_course_result[index].is_manual"
                            class="mt-1" small
                            color="primary"
                            outlined
                          >
                            手動入力
                          </v-chip>
                        </div>
                      </validation-provider>
                    </keep-alive>
                  </div>
                  <!-- 2項目整数入力の場合（血圧コース）（SP） -->
                  <div class="td-text-sp font-weight-bold td-blood-pressure-sp" v-if="course.result_type === 'DualInteger'">
                    <v-row no-gutters class="justify-space-between align-center">
                      <v-col cols="1">
                        <span class="result-input__subtext">上</span>
                      </v-col>
                      <v-col cols="11">
                        <keep-alive>
                          <validation-provider
                            :name="course.name"
                            :rules="setRule(course.result_type)"
                            v-slot="{ errors }"
                            :vid="'attribute-' + course.id + '-' + dateValueForSP.date + '-1'"
                          >
                            <v-text-field
                              :value="dateValueForSP.select_course_result[index].dual_integer_1"
                              :error-messages="errors"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              outlined
                              height="46"
                              class="c-custom--v-input"
                              hide-details="auto"
                              @input="changeDualInteger1Data($event, dateValueForSP, index)"
                            >
                            </v-text-field>
                          </validation-provider>
                        </keep-alive>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="justify-space-between align-center">
                      <v-col cols="1">
                        <span class="result-input__subtext">下</span>
                      </v-col>
                      <v-col cols="11">
                        <keep-alive>
                          <validation-provider
                            :name="course.name"
                            :rules="setRule(course.result_type)"
                            v-slot="{ errors }"
                            :vid="'attribute-' + course.id + '-' + dateValueForSP.date + '-2'"
                          >
                            <v-text-field
                              :value="dateValueForSP.select_course_result[index].dual_integer_2"
                              :error-messages="errors"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              outlined
                              height="46"
                              class="c-custom--v-input"
                              hide-details="auto"
                              @input="changeDualInteger2Data($event, dateValueForSP, index)"
                            >
                            </v-text-field>
                          </validation-provider>
                        </keep-alive>
                      </v-col>
                    </v-row>
                    <div class="is_manual_for_SP">
                      <v-chip
                        v-if="dateValueForSP.select_course_result[index].is_manual"
                        class="mt-1" small
                        color="primary"
                        outlined
                      >
                        手動入力
                      </v-chip>
                    </div>
                  </div>
                </div>

                <!-- 血圧の入力欄（SP） -->
                <div class="c-result-dialog-card mt-6 font-weight-bold" v-if="!isSelectedBloodPressureCourse">
                  <v-row no-gutters class="justify-space-between align-center pb-4">
                    <v-col cols="12">
                      <span class="result-input-dialog__title ma-0 pb-3">
                        血圧
                      </span>
                    </v-col>
                  </v-row>
                  <div class="td-text-sp td-blood-pressure-sp">
                    <v-row no-gutters class="justify-space-between align-center">
                      <v-col cols="1">
                        <span class="result-input__subtext">上</span>
                      </v-col>
                      <v-col cols="11">
                        <keep-alive>
                          <validation-provider
                            name="血圧(上)"
                            :rules="setRule('bloodPressure')"
                            v-slot="{ errors }"
                            :vid="'attribute-top_blood_pressure-' + dateValueForSP.date"
                          >
                            <v-text-field
                              :value="dateValueForSP.top_blood_pressure"
                              :error-messages="errors"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              outlined
                              height="46"
                              class="c-custom--v-input"
                              :class="{'no-errors': !errors.length}"
                              @input="changeTopBloodPressure($event, dateValueForSP)"
                            >
                            </v-text-field>
                          </validation-provider>
                        </keep-alive>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="justify-space-between align-center">
                      <v-col cols="1">
                        <span class="result-input__subtext">
                          下
                        </span>
                      </v-col>
                      <v-col cols="11">
                        <keep-alive>
                          <validation-provider
                            name="血圧(下)"
                            :rules="setRule('bloodPressure')"
                            v-slot="{ errors }"
                            :vid="'attribute-bottom_blood_pressure-' + dateValueForSP.date"
                          >
                            <v-text-field
                              :value="dateValueForSP.bottom_blood_pressure"
                              :error-messages="errors"
                              :disabled="isSubmitting || !isCampaignPeriod"
                              outlined
                              height="46"
                              class="c-custom--v-input"
                              :class="{'no-errors': !errors.length}"
                              @input="changeBottomBloodPressure($event, dateValueForSP)"
                            >
                            </v-text-field>
                          </validation-provider>
                        </keep-alive>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- メモ欄（SP） -->
                <div class="c-result-dialog-card mt-6 font-weight-bold">
                  <v-row
                    no-gutters
                    class="justify-space-between align-center pb-4"
                  >
                    <v-col cols="12">
                      <span class="result-input-dialog__title ma-0 pb-3 font-weight-bold">
                        メモ欄
                      </span>
                    </v-col>
                  </v-row>
                  <div class="td-memo-sp">
                    <v-textarea
                    :value="dateValueForSP.note"
                    :disabled="isSubmitting || !isCampaignPeriod"
                    outlined
                    height="270"
                    name="input_memo"
                    class="c-custom--v-input"
                    @input="changeNote($event, dateValueForSP)"
                    ></v-textarea>
                  </div>
                </div>
                <div class="mt-15 mb-6">
                  <v-btn
                    rounded
                    x-large
                    elevation="0"
                    class="c-result-btn--storage c-custom--w-100 font-weight-bold"
                    style="background-color: #FFE34F !important;"
                    @click="save()"
                    :loading="isSubmitting"
                  >
                  <span>保存する</span>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </validation-observer>
      </div>
    </div>
    <!-- キャンペーン終了ポップアップ -->
    <v-dialog
      v-model="activeCompleteMsg"
      max-width="600px"
    >
      <template>
        <v-card class="campain-end">
          <div class="campain-end-message">
            健康チャレンジキャンペーンの取り組み<br/>
            お疲れさまでした！
          </div>
          <img width="300" :src="'/image/Challenge_Goal.png'" />
          <div class="campain-end-message-caption">
            アンケートに未回答の方は、回答をお願いします。<br>
            引き続き健康を意識した生活を送りましょう！
          </div>
        </v-card>
      </template>
    </v-dialog>

    <SuccessSnackbar ref="snackbar"/>
    <ContinueBonusDialog ref="dialog"/>
    <SaveMobileAppHealthData
      v-if="
        !propsIsLoading &&
        isCampaignPeriod &&
        isMobileApp &&
        needsSaveHealthDataFromMobileApp &&
        ((stepCountIntegrateCourseId && hasWalkingPointListFromMobileApp) ||
          (weightIntegrateCourseId && hasWeightListFromMobileApp) ||
          (bloodPressureIntegrateCourseId && hasBloodPressureListFromMobileApp))
      "
      :dailyValueList="dailyValueList"
      :campaignUser="campaignUser"
      :isSubmitting="isSubmitting"
      :stepCountIntegrateCourseId="stepCountIntegrateCourseId"
      :weightIntegrateCourseId="weightIntegrateCourseId"
      :bloodPressureIntegrateCourseId="bloodPressureIntegrateCourseId"
      @inputErrorFromSaveMobileAppHealthData="inputErrorFromSaveMobileAppHealthData"
      @refreshFromSaveMobileAppHealthData="refreshFromSaveMobileAppHealthData"
      @saveMobileAppHealthDataSubmitting="saveMobileAppHealthDataSubmitting"
    ></SaveMobileAppHealthData>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import JsonToCsv from '../../utils/JsonToCsv'
import _ from 'lodash'
import { integer, max_value as maxValue, min_value as minValue, regex } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import { isHoliday } from '@holiday-jp/holiday_jp'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
const SuccessSnackbar = () => import('../util/SuccessSnackbar.vue')
const ContinueBonusDialog = () => import('./ContinueBonusDialog.vue')
const SaveMobileAppHealthData = () => import('./mobile_app/SaveMobileAppHealthData.vue')

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('max_value', {
  ...maxValue,
  message: '{_field_}は{max}以内で入力してください'
})
extend('min_value', {
  ...minValue,
  message: '{_field_}は{min}以上で入力してください'
})
extend('regex', {
  ...regex,
  message: '{_field_}は半角数字（小数点第二位まで）で入力してください'
})
extend('integer', {
  ...integer,
  message: '{_field_}は半角数字（整数）で入力してください'
})

const saveResult = async (campaignId, dailyResultInputList, saveResultInputOption) => {
  const { data: { saveResult: data } } = await GraphqlAPI(saveResultMutation(campaignId, dailyResultInputList, saveResultInputOption))
  return data
}

const getCourseValue = (resultType, selectCourse) => {
  switch (resultType) {
    case 'CircleAndCross':
      return nullToEmpty(CIRCLE_CROSS_VALUE[selectCourse.circle_and_cross])
    case 'CircleCrossNone':
      return nullToEmpty(CIRCLE_CROSS_VALUE[selectCourse.circle_and_cross])
    case 'Integer':
      return nullToEmpty(selectCourse.integer)
    case 'Number':
      return nullToEmpty(getNumValueZeroFill(selectCourse.number))
    case 'DualInteger': {
      const v = nullToEmpty(selectCourse.dual_integer_1) + '_' + nullToEmpty(selectCourse.dual_integer_2)
      return v === '_' ? '' : v
    }
  }
}

const saveResultMutation = (campaignId, dailyResultInputList, saveResultInputOption) => `
  mutation saveResult {
    saveResult(
      input: {
        campaign_id: "${campaignId}",
        daily_result: ${convertArrayString(dailyResultInputList)},
        save_result_option: ${convertObjString(saveResultInputOption)}
      }
    )
  }
`

const convertArrayString = (arrayData) => {
  const resArry = arrayData.map(obj => {
    const arr = Object.keys(obj).map(key => {
      if (obj[key] instanceof Array) {
        const courseArry = obj[key]
        const arr2 = courseArry.map(obj2 => {
          const objStr = Object.keys(obj2).map(key2 => {
            if (obj2[key2] === 0 || obj2[key2]) {
              if (typeof obj2[key2] === 'number' || typeof obj2[key2] === 'boolean') {
                return `${key2}: ${obj2[key2]}`
              } else {
                return `${key2}: "${obj2[key2]}"`
              }
            }
          })
          return `{${objStr.join(', ')}}`
        })
        const arr2str = `[${arr2.join(', ')}]`
        return `${key}: ${arr2str}`
      } else if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
        return `${key}: ${obj[key]}`
      } else if (obj[key]) {
        return `${key}: ${JSON.stringify(obj[key])}`
      }
    })
    return `{${arr.join(', ')}}`
  })
  return `[${resArry.join(', ')}]`
}

const convertObjString = (obj) => {
  const arr = Object.keys(obj).map((key) => {
    if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
      return `${key}: ${obj[key]}`
    }
  })
  return `{${arr.join(',')}}`
}

const checkAppUserStatusQuery = (campaignId) => `
  query checkAppUserStatus {
    checkAppUserStatus (campaign_id: "${campaignId}")
  }
`
const checkAppUserStatus = async (campaignId) => {
  const { data: { checkAppUserStatus: data } } = await GraphqlAPI(checkAppUserStatusQuery(campaignId))
  return data
}

// Number型の小数点、0埋め
const getNumValueZeroFill = (numValue) => {
  if (numValue === 0 || numValue) {
    const strValue = numValue.toString()
    return strValue.indexOf('.') === -1 ? strValue + '.0' : strValue
  }
  return null
}

const CIRCLE_CROSS_VALUE = {
  circle: '○',
  cross: '×',
  none: '該当なし'
}

const nullToEmpty = (item) => {
  if (item === null || typeof item === 'undefined') {
    return ''
  }
  return item
}

export default {
  mixins: [JsonToCsv],
  name: 'ResultInput',
  data () {
    return {
      showYearForSP: '',
      showDateForSP: '',
      dateValueForSP: [], // SP用のデータ登録用
      dailyValueList: [],
      originDailyValueList: [], // CSV出力用（DBに登録されているデータ）
      updateDailyValueList: [],
      targetDateList: [],
      selectedCourseList: [],
      isCampaignPeriod: false,
      isCampaignStarted: false,
      activeCompleteMsg: false,
      isSubmitting: false,
      hasError: false,
      participants: '',
      myRank: '',
      hasChange: false,
      stepCountIntegrateCourseId: null, // 歩数連動機能
      weightIntegrateCourseId: null, // 体重連動機能
      bloodPressureIntegrateCourseId: null, // 血圧連動機能
      manualMap: new Map(),
      showAppStatusInfo: false,
      showHasChange: false,
      errorMessage: null,
      calendar: [],
      displayYearMonthInfo: '', // SP時 カレンダー表示中の年月
      formatDisplayYearMonthInfo: '',
      displayPrevMonth: false,
      displayNextMonth: false,
      siteOpen: null,
      siteClose: null,
      startDate: null,
      endDate: null,
      spDialogReady: false, // render制御用
      InputDialog: false, // SP時の達成状況確認の詳細ダイアログ
      isMobileApp: false,
      needsSaveHealthDataFromMobileApp: false,
      hasWalkingPointListFromMobileApp: false,
      hasWeightListFromMobileApp: false,
      hasBloodPressureListFromMobileApp: false
    }
  },
  props: [
    'propsIsLoading',
    'campaignUser',
    'isSelectedBloodPressureCourse',
    'propsDailyValueList',
    'numberOfSteps'
  ],
  components: {
    ValidationObserver,
    ValidationProvider,
    ContinueBonusDialog,
    SuccessSnackbar,
    SaveMobileAppHealthData
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    campaignOption () {
      return this.$store.getters.getCampaignOption
    },
    appEntryStatus () {
      return this.$store.getters.getAppEntryStatus
    },
    isMobile () { // モバイル判定
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  watch: {
    propsDailyValueList: {
      handler (newValue) {
        if (newValue !== null) {
          this.resultListFormatter(newValue)
          this.originDailyValueList = this.dailyValueList.map(list => ({ ...list }))
        }
      },
      deep: true
    },
    isSubmitting (newValue) {
      this.$emit('submit', newValue)
    },
    hasChange (newValue) {
      this.$emit('change', newValue)
      this.showHasChange = newValue && !this.hasError
    },
    hasError (newValue) {
      this.showHasChange = this.hasChange && !newValue
    },
    showHasChange (newValue) {
      this.$emit('changeShowHasChange', newValue)
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    if (this.campaign.is_app_challenge && this.$store.getters.getAppEntryStatus === null) {
      this.featchAppEntryStatus()
    }
    this.getCampaignJson()

    // 対象期間の取得
    this.startDate = dayjs(this.campaign.start, 'YYYY-MM-DD')
    this.endDate = dayjs(this.campaign.end, 'YYYY-MM-DD')
    this.siteOpen = dayjs(this.campaign.site_open, 'YYYY-MM-DD')
    this.siteClose = dayjs(this.campaign.site_close, 'YYYY-MM-DD')
    this.isCampaignPeriod = dayjs() >= this.startDate && dayjs() < this.siteClose.add(1, 'days')
    this.isCampaignStarted = dayjs() >= this.startDate

    // SP時のカレンダー初期表示情報の設定
    if (dayjs() > this.endDate) {
      this.displayYearMonthInfo = this.endDate
    } else {
      this.displayYearMonthInfo = dayjs()
    }
    this.updateCalendar()

    // 記録入力部分の日付リスト（targetDateList）を設定
    let countDate = this.startDate.clone()
    while (countDate.unix() <= this.endDate.unix() && countDate <= dayjs()) {
      this.targetDateList.push(countDate.format('YYYY-MM-DD'))
      countDate = countDate.add(1, 'days')
    }
    this.targetDateList.reverse()

    // 記録情報の取得
    if (this.propsDailyValueList !== null) {
      this.resultListFormatter(this.propsDailyValueList)
      this.originDailyValueList = this.dailyValueList.map(list => ({ ...list }))
    }
    // モバイルアプリ歩数連携判定
    this.isMobileApp = this.$store.getters.getIsMobileApp
    this.needsSaveHealthDataFromMobileApp = this.$store.getters.getNeedsSaveHealthDataFromMobileApp // 表示中キャンペーンのモバイル健康データ自動保存可否
    this.hasWalkingPointListFromMobileApp = this.$store.getters.getWalkingPointListFromMobileApp.length > 0
    this.hasWeightListFromMobileApp = this.$store.getters.getWeightListFromMobileApp.length > 0
    this.hasBloodPressureListFromMobileApp = this.$store.getters.getBloodPressureListFromMobileApp.length > 0

    // アプリチャレンジステータス表示するか
    // キャンセルステータスの場合、コース変更可能期間後は、ここには表示しない
    if (this.campaign.is_app_challenge) {
      const courseDeletableEnd = dayjs(this.campaign.course_deletable_end, 'YYYY-MM-DD').add(1, 'days')
      const isCourseChangeablePeriod = dayjs() < courseDeletableEnd
      this.showAppStatusInfo = this.appEntryStatus && this.appEntryStatus !== 'Unregistered' && !(!isCourseChangeablePeriod && (this.appEntryStatus === 'Canceled' || this.appEntryStatus === 'Expired'))
    }
  },
  methods: {
    isToday (date) {
      const today = new Date()
      return (
        date <= this.endDate &&
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      )
    },
    // SP用 カレンダーから記録情報の取得
    getDailyInfo (formatDate) {
      return this.dailyValueList.find(dateValue => dateValue.date === formatDate)
    },
    // SP用 日付押下時の結果情報の取得
    async setDateValueForSP (formatDate) {
      this.spDialogReady = false
      this.InputDialog = false
      this.dateValueForSP = this.dailyValueList.find(dateValue => dateValue.date === formatDate)

      // DOM更新を待つ
      await this.$nextTick()
      this.spDialogReady = true
      this.InputDialog = true
    },
    // SP時カレンダー前月めくり部分
    prev () {
      this.displayYearMonthInfo = this.displayYearMonthInfo.subtract(1, 'month')
      this.updateCalendar()
    },
    // SP時カレンダー来月めくり部分
    next () {
      this.displayYearMonthInfo = this.displayYearMonthInfo.add(1, 'month')
      this.updateCalendar()
    },
    updateCalendar () {
      this.displayPrevMonth = this.displayYearMonthInfo.subtract(1, 'month').startOf('month') >= this.startDate.startOf('month')
      this.displayNextMonth = this.displayYearMonthInfo.add(1, 'month').startOf('month') <= this.endDate.startOf('month')
      this.formatDisplayYearMonthInfo = this.displayYearMonthInfo.format('YYYY年MM月')
      this.createCalendar(this.displayYearMonthInfo.year(), this.displayYearMonthInfo.month() + 1, 0) // カレンダーのリスト取得
    },
    createCalendar (year, month, offset) {
      month = month - 1
      // 前月の日を埋める
      const prevPaddingDays = (() => {
        const firstDay = (new Date(year, month)).getDay() // 今月の1日の曜日を取得
        // 埋める日数を求める（日曜日スタートがoffset:0で、月曜日からにする場合はoffset:1にする）
        const paddingDayCount = (firstDay + 7 - offset) % 7
        const prevLastDate = (new Date(year, month, 0)).getDate() // 前月の最後の日付を取得
        return _.range(prevLastDate - paddingDayCount + 1, prevLastDate + 1).map((day) => ({
          date: new Date(year, month - 1, day),
          formatDate: dayjs(new Date(year, month - 1, day)).format('YYYY-MM-DD'),
          day,
          weekday: dayjs(new Date(year, month - 1, day)).day(), // 曜日
          isHoliday: isHoliday(new Date(year, month - 1, day)), // 祝日
          canClick: false
        }))
      })()

      // 今月の日付リストを生成する
      const currentDays = (() => {
        const lastDate = new Date(year, month + 1, 0)
        const currentDayCount = lastDate.getDate()
        return _.range(1, currentDayCount + 1).map((day) => ({
          date: new Date(year, month, day),
          formatDate: dayjs(new Date(year, month, day)).format('YYYY-MM-DD'),
          day,
          weekday: dayjs(new Date(year, month, day)).day(), // 曜日
          isHoliday: isHoliday(new Date(year, month, day)), // 祝日
          canClick: dayjs(new Date(year, month, day)).unix() >= this.startDate.unix() &&
            dayjs(new Date(year, month, day)).unix() <= this.endDate.unix() &&
            dayjs(new Date(year, month, day)) <= dayjs()
        }))
      })()

      // 来月の日を埋める
      const nextPaddingDays = (() => {
        const paddingDayCount = (42 - (prevPaddingDays.length + currentDays.length)) % 7
        return _.range(1, paddingDayCount + 1).map((day) => ({
          date: new Date(year, month + 1, day),
          formatDate: dayjs(new Date(year, month + 1, day)).format('YYYY-MM-DD'),
          day,
          weekday: dayjs(new Date(year, month + 1, day)).day(), // 曜日
          isHoliday: isHoliday(new Date(year, month + 1, day)), // 祝日
          canClick: false
        }))
      })()

      // 結合する
      const flatCalendar = [
        ...prevPaddingDays,
        ...currentDays,
        ...nextPaddingDays
      ]

      // 2次元配列にして返す
      const calendar = _.range(0, flatCalendar.length / 7).map((i) => {
        return flatCalendar.slice(i * 7, (i + 1) * 7)
      })
      this.calendar = calendar
    },

    // 保存する
    async save () {
      this.isSubmitting = true
      this.hasError = false
      this.$emit('saveInputError', this.hasError)
      const isValidateError = await this.$refs.observer.validate()
      if (!isValidateError) {
        this.hasError = true
        this.$emit('saveInputError', this.hasError)
        // this.errorMessage = '入力内容にエラーがあります。確認してください。'
        this.isSubmitting = false
        return
      }

      const filteredList = []
      let isEditEndDate = false

      // 保存用にレコードを整形
      this.updateDailyValueList.forEach(dv => {
        const filteredCourseList = []
        for (const ce of dv.select_course_result) {
          // 自動連携コースかつ手動入力時はis_manualを設定
          const isIntegrateCourseAndInputted =
            (ce.course_id === this.stepCountIntegrateCourseId && (ce.integer === 0 || ce.integer)) ||
            (ce.course_id === this.weightIntegrateCourseId && (ce.number === 0 || ce.number)) ||
            (ce.course_id === this.bloodPressureIntegrateCourseId && (ce.dual_integer_1 === 0 || ce.dual_integer_1 || ce.dual_integer_2 === 0 || ce.dual_integer_2))
          const isManual = Boolean(isIntegrateCourseAndInputted && this.manualMap.has(ce.course_id) && this.manualMap.get(ce.course_id).has(dv.date))

          filteredCourseList.push({
            course_id: ce.course_id,
            circle_and_cross: ce.circle_and_cross,
            integer: (ce.integer === 0 || ce.integer) ? parseInt(ce.integer) : null,
            number: (ce.number === 0 || ce.number) ? parseFloat(ce.number) : null,
            dual_integer_1: (ce.dual_integer_1 === 0 || ce.dual_integer_1) ? parseInt(ce.dual_integer_1) : null,
            dual_integer_2: (ce.dual_integer_2 === 0 || ce.dual_integer_2) ? parseInt(ce.dual_integer_2) : null,
            is_manual: isManual ? Boolean(true) : null
          })
        }
        const newDv = {}
        if (dv.top_blood_pressure || dv.bottom_blood_pressure || dv.note || (filteredCourseList && filteredCourseList.length > 0)) {
          // キャンペーン最終日の更新チェック
          if (!isEditEndDate) {
            isEditEndDate = dv.date === this.campaign.end
          }

          // 入力内容の設定
          newDv.date = dv.date
          newDv.top_blood_pressure = dv.top_blood_pressure ? parseInt(dv.top_blood_pressure) : null
          newDv.bottom_blood_pressure = dv.bottom_blood_pressure ? parseInt(dv.bottom_blood_pressure) : null
          newDv.note = dv.note ? dv.note : null
          newDv.select_course_result = filteredCourseList
          filteredList.push(newDv)
        }
      })
      try {
        const saveResultInputOption = {}

        // 継続ボーナス付与
        let continueBonusOutput
        if (this.campaign.is_continue_bonus) {
          continueBonusOutput = await this.$store.dispatch('setContinueBonusProcessorOutput', { campaignId: this.campaign.id, type: 'write' })
          saveResultInputOption.is_continue_bonus_complete = continueBonusOutput.is_continue_bonus_complete
          saveResultInputOption.continue_bonus_point = continueBonusOutput.continue_bonus_point
        }

        // キャンペーン終了判定
        const isCampaignComplete = isEditEndDate && !this.activeCompleteMsg && !this.campaignUser.is_campaign_complete
        if (isCampaignComplete) {
          saveResultInputOption.is_campaign_complete = true
        }

        // 結果情報保存API
        // ※継続ボーナスポイント(CampaignUser, Userview)更新、キャンペーン終了フラグ(CampaignUser)更新、を含む
        const saveResultResponse = await saveResult(this.campaign.id, filteredList, saveResultInputOption)

        // キャンペーン終了通知メッセージの表示
        let isActiveComplete = false
        if (saveResultResponse === 'ALL_RESULTS_SAVED' && isCampaignComplete) {
          isActiveComplete = true
        }

        // 保持データの更新
        this.$emit('fetchData', async () => {
          this.updateDailyValueList = []
          this.hasChange = false
          this.isSubmitting = false
          this.InputDialog = false
          if (saveResultResponse === 'INVALID_DATE_CONTAIN') {
            await this.$refs.snackbar.open('未来日のデータが含まれていたため、一部の保存が失敗しました。')
          } else if (saveResultResponse === 'ALL_RESULTS_SAVED') {
            this.activeCompleteMsg = isActiveComplete
            if (!this.activeCompleteMsg) {
              await this.$emit('saveSuccess')
            }
          }
        })

        // 継続ボーナスダイアログの表示
        if (this.campaign.is_continue_bonus && continueBonusOutput && continueBonusOutput.first_continue.status) {
          await this.$refs.dialog.open({ completeIndex: continueBonusOutput.first_continue.index + 1 })
        }
      } catch (e) {
        this.$emit('inputError', '結果記録の保存に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.isSubmitting = false
        this.InputDialog = false
      }
    },
    getResultValue (result) {
      const resultType = this.findResultType(result.course_id)
      return getCourseValue(resultType, result)
    },
    findResultType (courseId) {
      const courseInfo = this.selectedCourseList.find(elm => courseId === elm.id)
      return courseInfo.result_type
    },

    // CSV出力
    csvLine () {
      this.isSubmitting = true
      const csvData = []
      if (this.selectedCourseList) {
        for (const selectCourse of this.selectedCourseList) {
          csvData.push({
            コース名: selectCourse.name,
            コースID: selectCourse.id
          })
        }
        if (!this.isSelectedBloodPressureCourse) {
          csvData.push({ コース名: '上の血圧' })
          csvData.push({ コース名: '下の血圧' })
        }
        csvData.push({ コース名: 'メモ欄' })

        const deepCopyList = this.originDailyValueList.map(list => ({ ...list }))
        for (const dailyResult of deepCopyList.reverse()) {
          // 1日の結果毎に格納
          const targetDate = dailyResult.show_date
          for (const result of dailyResult.select_course_result) {
            const csvRow = csvData.find(csvRow => csvRow['コースID'] === result.course_id)
            csvRow[targetDate] = this.getResultValue(result)
          }
          if (!this.isSelectedBloodPressureCourse) {
            const topBloodPressure = csvData.find(csvRow => csvRow['コース名'] === '上の血圧')
            topBloodPressure[targetDate] = nullToEmpty(dailyResult.top_blood_pressure)
            const bottomBloodPressure = csvData.find(csvRow => csvRow['コース名'] === '下の血圧')
            bottomBloodPressure[targetDate] = nullToEmpty(dailyResult.bottom_blood_pressure)
          }
          const note = csvData.find(csvRow => csvRow['コース名'] === 'メモ欄')
          note[targetDate] = nullToEmpty(dailyResult.note)
        }
        for (const row of csvData) {
          delete row['コースID']
        }
      }
      const filename = 'CourseResultList'
      const csvTitle = filename + '_' + this.$_getDateString() + '.csv'
      const labels = Object.getOwnPropertyNames({ ...csvData[0] })
      const labelsConf = this.$_createCsvLabelsConf(labels)
      const separator = ','
      this.$_jsonToCsv(csvTitle, csvData, labelsConf, separator)
      this.isSubmitting = false
    },
    toggleSelection (value, dateValue, index) {
      if (dateValue.select_course_result[index].circle_and_cross === value) {
        dateValue.select_course_result[index].circle_and_cross = null // 〇✕両方未選択状態にする
      } else {
        dateValue.select_course_result[index].circle_and_cross = value
      }
      this.changeData(dateValue)
    },
    changeIntegerData (event, dateValue, index) {
      if (dateValue.select_course_result[index].course_id === this.stepCountIntegrateCourseId) {
        if (!this.manualMap.has(this.stepCountIntegrateCourseId)) {
          this.manualMap.set(this.stepCountIntegrateCourseId, new Set())
        }
        this.manualMap.get(this.stepCountIntegrateCourseId).add(dateValue.date)
      }
      dateValue.select_course_result[index].integer = event
      this.changeData(dateValue)
    },
    changeNumberData (event, dateValue, index) {
      if (dateValue.select_course_result[index].course_id === this.weightIntegrateCourseId) {
        if (!this.manualMap.has(this.weightIntegrateCourseId)) {
          this.manualMap.set(this.weightIntegrateCourseId, new Set())
        }
        this.manualMap.get(this.weightIntegrateCourseId).add(dateValue.date)
      }
      dateValue.select_course_result[index].number = event
      this.changeData(dateValue)
    },
    changeDualInteger1Data (event, dateValue, index) {
      if (dateValue.select_course_result[index].course_id === this.bloodPressureIntegrateCourseId) {
        if (!this.manualMap.has(this.bloodPressureIntegrateCourseId)) {
          this.manualMap.set(this.bloodPressureIntegrateCourseId, new Set())
        }
        this.manualMap.get(this.bloodPressureIntegrateCourseId).add(dateValue.date)
      }
      dateValue.select_course_result[index].dual_integer_1 = event
      this.changeData(dateValue)
    },
    changeDualInteger2Data (event, dateValue, index) {
      if (dateValue.select_course_result[index].course_id === this.bloodPressureIntegrateCourseId) {
        if (!this.manualMap.has(this.bloodPressureIntegrateCourseId)) {
          this.manualMap.set(this.bloodPressureIntegrateCourseId, new Set())
        }
        this.manualMap.get(this.bloodPressureIntegrateCourseId).add(dateValue.date)
      }
      dateValue.select_course_result[index].dual_integer_2 = event
      this.changeData(dateValue)
    },
    changeTopBloodPressure (event, dateValue) {
      dateValue.top_blood_pressure = event
      this.changeData(dateValue)
    },
    changeBottomBloodPressure (event, dateValue) {
      dateValue.bottom_blood_pressure = event
      this.changeData(dateValue)
    },
    changeNote (event, dateValue) {
      dateValue.note = event
      this.changeData(dateValue)
    },
    changeData (dateValue) {
      this.hasChange = true
      const targetDailyData = this.updateDailyValueList.some((elm, i) => {
        return elm.date === dateValue.date
      })
      if (targetDailyData) {
      } else {
        this.updateDailyValueList.push(dateValue)
      }
    },
    resultListFormatter (listDailyResult) {
      this.dailyValueList = []
      this.selectedCourseList = []
      const dailyResultList = listDailyResult.daily_results
      const selectedCourseList = listDailyResult.select_course_list
      const descTargetDateList = Array.from(this.targetDateList)
      const me = this

      // 選択コース（名）を画面表示用に成形
      for (const selectedCourse of listDailyResult.select_course_list) {
        // カスタム目標設定項目がある場合に、カスタム目標名を画面上に表示させるための処理
        const targetCourse = this.campaignUser.custom_objective_list.find(elm => {
          return elm.course_id === selectedCourse.id
        })
        this.selectedCourseList.push({
          ...selectedCourse,
          custom_objective: targetCourse.custom_objective
        })
      }

      // 歩数コースに参加していたら、IDを取得
      this.stepCountIntegrateCourseId = selectedCourseList.find(elm => elm.unit === '歩')?.id
      // 体重コースに参加していたら、IDを取得
      this.weightIntegrateCourseId = selectedCourseList.find(elm => elm.unit === 'kg')?.id
      // 血圧コースに参加していたら、IDを取得
      this.bloodPressureIntegrateCourseId = selectedCourseList.find(elm => elm.unit === 'mmHg')?.id

      // 日々の記録データを画面表示用に成形
      for (const date of descTargetDateList) {
        const dailyResultObj = dailyResultList.find(elm => date === elm.meta)
        // 対象日の結果情報があるとき
        if (dailyResultObj) {
          const valueObj = {
            date: dayjs(dailyResultObj.meta).format('YYYY-MM-DD'),
            show_year: dayjs(dailyResultObj.meta).year(),
            show_date: dayjs(dailyResultObj.meta).format('MM/DD（dd）'),
            day: dayjs(dailyResultObj.meta).day(),
            isHoliday: isHoliday(dailyResultObj.meta), // 祝日
            is_today: dailyResultObj.meta === dayjs().format('YYYY-MM-DD'),
            is_inputted: dailyResultObj.is_inputted,
            top_blood_pressure: dailyResultObj.top_blood_pressure,
            bottom_blood_pressure: dailyResultObj.bottom_blood_pressure,
            note: dailyResultObj.note,
            disp_note: dailyResultObj.note
          }
          if (dailyResultObj.select_course_result) {
            const courseList = []
            for (const selectCourse of selectedCourseList) {
              const existCourse = dailyResultObj.select_course_result.find(pastCourseResult => {
                return pastCourseResult.course_id === selectCourse.id
              })
              courseList.push({
                course_id: selectCourse.id,
                circle_and_cross: existCourse ? existCourse.circle_and_cross : null,
                integer: existCourse ? existCourse.integer : null,
                number: existCourse ? getNumValueZeroFill(existCourse.number) : null,
                dual_integer_1: existCourse ? existCourse.dual_integer_1 : null,
                dual_integer_2: existCourse ? existCourse.dual_integer_2 : null,
                is_manual: existCourse ? existCourse.is_manual : null
              })
            }
            valueObj.select_course_result = courseList
          }
          me.dailyValueList.push(valueObj)

        // 対象日の結果情報がないとき（空のオブジェクトを返す）
        } else {
          const selectCourseResult = []
          for (const elm of selectedCourseList) {
            selectCourseResult.push({
              course_id: elm.id,
              circle_and_cross: null,
              integer: null,
              number: null,
              dual_integer_1: null,
              dual_integer_2: null
            })
          }
          const obj = {
            date: dayjs(date).format('YYYY-MM-DD'),
            show_year: dayjs(date).year(),
            show_date: dayjs(date).format('MM/DD（dd）'),
            day: dayjs(date).day(),
            is_today: date === dayjs().format('YYYY-MM-DD'),
            is_inputted: false,
            top_blood_pressure: null,
            bottom_blood_pressure: null,
            note: null,
            select_course_result: selectCourseResult
          }
          me.dailyValueList.push(obj)
        }
      }
    },
    // cloudfront→S3からjsonファイルのキャンペーン参加者人数を取得 ※ログイン画面との整合性を合わせるため
    getCampaignJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/campaign_list.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const campaignList = this.response
            const targetCampaign = campaignList.find(item => item.is_continuity === me.campaign.is_continuity)
            if (targetCampaign) {
              me.participants = targetCampaign.participants
            }
          }
        }
      }
    },
    async featchAppEntryStatus () {
      try {
        const appEntryStatus = await checkAppUserStatus(this.campaign.id)
        this.$store.dispatch('setAppEntryStatus', appEntryStatus)
      } catch (e) {
        this.$log.debug(e)
      }
    },
    openDetailPDF (target) {
      window.open('/course/detail/' + target + '.pdf', '_blank')
    },
    // 記録入力時のバリデーションルールの設定
    setRule (resultType) {
      const ruleList = {}
      if (resultType === 'Integer') {
        ruleList.integer = true
        ruleList.max_value = 99999
        ruleList.min_value = 0
      }
      if (resultType === 'Number') {
        ruleList.regex = /(^[0-9\-+]+)(?:\.[0-9]{0,2})?$/
        ruleList.max_value = 1000
        ruleList.min_value = 0
      }
      if (resultType === 'DualInteger') { // bloodPressureと同じバリデーションとする
        ruleList.integer = true
        ruleList.max_value = 500
        ruleList.min_value = 0
      }
      if (resultType === 'bloodPressure') {
        ruleList.integer = true
        ruleList.max_value = 500
        ruleList.min_value = 0
      }
      return ruleList
    },
    inputErrorFromSaveMobileAppHealthData (errorMessage) { // モバイルアプリ健康データ自動保存エラー
      this.$emit('inputError', errorMessage)
      this.isSubmitting = false
      this.$emit('changeIsSavingMobileAppHealthData', false)
    },
    refreshFromSaveMobileAppHealthData (saveResultResponse) { // モバイルアプリ健康データ自動保存成功
      this.$emit('fetchData', async () => {
        this.updateDailyValueList = []
        this.hasChange = false
        this.isSubmitting = false
        this.InputDialog = false
        if (saveResultResponse === 'INVALID_DATE_CONTAIN') {
          this.$refs.snackbar.open('未来日のデータが含まれていたため、一部の保存が失敗しました。')
          this.$emit('changeIsSavingMobileAppHealthData', false)
        } else if (saveResultResponse === 'ALL_RESULTS_SAVED') {
          this.$emit('saveSuccessFromSaveMobileAppHealthData')
        }
      })
    },
    saveMobileAppHealthDataSubmitting (isSubmitting) { // モバイルアプリ健康データ自動保存
      this.isSubmitting = isSubmitting
      this.$emit('changeIsSavingMobileAppHealthData', isSubmitting)
    }
  }
}
</script>
<style lang="scss">
/* v-input 上書き => &.c-custom--v-input のみ */
.v-input {
  &.c-custom--v-input {
    .v-input__slot {
      min-height: inherit !important;
      margin-bottom: 0 !important;
      background-color: #fff !important;
    }
    &.no-errors .v-text-field__details {
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    input {
      text-align: center;
    };
  }
}
/* v-btn 上書き => &.c-custom--v-btn のみ */
.v-btn {
  &.c-custom--v-btn__content--block {
    .v-btn__content {
      display: block;
    }
  }
  &.v-btn--disabled {
    opacity: 0.5; /* v-btn が disabled のとき半透明 */
    .day {
      &.sunday-red,
      &.saturday-blue {
        opacity: 0.5;
      }
    }
  }
}
/* v-toolbar 上書き => &.c-custom--v-toolbar のみ */
.v-toolbar {
  &.c-custom--v-toolbar__content--space-between {
    .v-toolbar__content {
      justify-content: space-between
    }
  }
}
</style>
<style scoped lang="scss">
.result-input {

  /* PC時カレンダー */
  .result-input-table {
    border: none;
    border-collapse: separate;
    border-spacing: 0 4px;
    thead {
      font-size: 14px;
      th {
        width: 12.5%;
        padding: 0 10px 0 20px;
        font-size: 20px;
        line-height: 1.2;
        &.th-days {
          width: 130px;
          min-width: 130px; // /* こちらを追加 */
          padding-left: 0;
        }
        &.th-check {
          width: 50px;
          min-width: 50px;
          padding-left: 0;
        }
        &.th-blood-pressure {
          padding-left: 40px;
          text-align: left;
        }
        &.th-memo {
          width: auto;
          padding-left: 20px;
          text-align: left;
        }
      }
      .result-input-table-th__row {
        display: flex;
        align-items: center;
        .result-input-table-th__col--title {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          flex-grow: 1;
          min-width: 3em;
          padding-right: 0.5em;
          text-align: left;
        }
        .result-input-table-th__col--info {
          width: 20px;
        }
      }
    }
    tbody {
      tr {
        position: relative;

        td { // 未記入時
          background-color: #E0F2EB;

          &:nth-of-type(1) {
            border-radius: 8px 0 0 8px;
          }

          &:nth-last-of-type(1) {
            border-radius: 0 8px 8px 0;
          }
        }

        &.is-updating { // 記入中、または記入完了後
          &:nth-of-type(odd) {
            td {
              background-color: #fff;
            }
          }
          &:nth-of-type(even) {
            td {
              background-color: #F5F5F5;
            }
          }
        }
      }
      td {
        position: relative;
        z-index: 1;
        padding: 16px 12px;

        &.td-check {
          .v-icon {
            color: #3DCEBB;
          }
        }

        &.td-memo {
          padding-right: 24px;
        }

        &.td-days {
          padding: 16px 0 16px 24px; // /* こちらに変更 */
          .td-days-year {
            display: block;
            font-size: 14px;
          }
          .td-days-day {
            &.is-sunday {
              color: #CC1D1D;
            }
            &.is-saturday {
              color: #206EB5;
            }
          }
        }
        &.td-blood-pressure {
          .td-blood-pressure__row {
            display: flex;
            align-items: center;
            justify-content: space-between;

            &:nth-of-type(1) {
              margin-bottom: 2px;
            }

            .td-blood-pressure__col {
              &.td-blood-pressure__col--title {
                width: 1.25em;
              }
              &.td-blood-pressure__col--input {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }

  /* SP時カレンダー */
  .result-input-table-sp {
    border: none;
    border-collapse: collapse;

    .v-btn {
      min-width: inherit;
      align-items: flex-start;
      &.result-input-table-sp-btn {
        height: 70px;
        background-color: rgba(255,255,255,0);

        .is-clear {
        }
      }
    }
    tr {
      &.day-of-week { // 曜日の行
        td {
          height: auto;
          padding: 9px 0;
          font-size: 12px;
        }
        td:first-child {
          color: #CC1D1D;
        }
        td:last-child {
          color: #206EB5;
        }
      }
      td {
        width: 14.2%;
        font-size: 16px;
        text-align: center;
        vertical-align: baseline;
        border-top: 1px #C7C7C7 solid;

        &.is-today {
          background-color: #FFE34F;
        }

        span {
          display: block;

          &.day {
            padding: 10px 0;
          }

          &.sunday-red {
            color: #CC1D1D;
          }

          &.saturday-blue {
            color: #206EB5;
          }

        }
      }
    }
  }
}
/* 選択ボタンの幅 */
.result-input__row {
  .result-input__col {
    width: 49%;
  }
}

/* 選択ボタン テーブル内 */
.theme--light.v-sheet--outlined,
.v-text-field--outlined fieldset {
  border-color: #C7C7C7; // rgba(0,0,0,0.38)
}

/* 選択ボタン モーダル内 */
.v-dialog.v-dialog--active .theme--light.v-sheet--outlined.v-card--link {
  border: 1px solid #C7C7C7 !important;
}
.td-text-sp {
  position: relative;
}
.td-blood-pressure-sp {
  .row {
    &:nth-of-type(1) {
      margin-bottom: 6px;
    }
  }
}

/* 選択ボタン スタイル */
.input-select--on {
  svg {
    stroke: #000;
  }
}
.input-select--off {
  svg {
    fill: #000;
  }
}
.v-item--active,
.v-dialog.v-dialog--active .theme--light.v-card .v-item--active {
  background-color: #19ADF8 !important;
  .input-select--on {
    svg {
      stroke: #fff;
    }
  }
  .input-select--off {
    svg {
      fill: #fff;
    }
  }
}
.outlined-when-disabled {
  border: 1px solid #C7C7C7 !important;
}

.active-txt {
  color:#fff;
}

.is_manual_for_SP {
  display: flex;
  justify-content: flex-end;
}

/* テキストボックスなどのグレーの文字やタイトル // カレンダー内とモーダル内 */
.result-input__subtext {
  font-size: 12px;
  color: #C7C7C7;

  &.result-input__subtext--unit {
    position: absolute;
    right:17px;
    top:50%;
    transform: translateY(-50%);
  }
}

/* モーダル内 */
.result-input-dialog {
}
.result-input-dialog__title {
  font-size: 18px;
}
.result-input-dialog__btn {
  font-size: 14px !important;
}
/* モーダル内 => 日付（SP） */
.result-input-dialog-date {

  .result-input-dialog-date__year {
    font-size: 14px;
    line-height: 1;
  }
  .result-input-dialog-date__days {
    font-size: 18px;
  }
}
</style>
